.action-list {
  background-color: var(--color-uva-white);
  border-radius: 0.5rem;
  box-shadow: 0 0 6px 2px rgb(0 0 0 / 15%);
  display: none;
  padding: 0.25rem;
  position: absolute;
  right: 0;
  top: calc(100% + 0.5rem);
  z-index: 100;
}

.action-list--open {
  display: block;
}

.action-list-container {
  position: relative;
}

.action-list [role="menuitem"] > * {
  background: 0;
  border: 0;
  border-radius: 0.25rem;
  cursor: pointer;
  display: block;
  font: inherit;
  margin: 0;
  padding: 0.5rem 0.75rem;
  text-align: left;
  white-space: pre;
  width: 100%;
}

.action-list [role="menuitem"] > *:not(:last-of-type) {
  border-bottom: 1px solid var(--color-grey-300);
}

.action-list [role="menuitem"] > *:hover {
  background-color: var(--color-grey-200);
}
